import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
import AddHolidays from './AddHolidays';
import UpdateHolidays from './UpdateHolidays';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { getHolidaysList } from '../../../../store/HR/Raqeeb/HolidaysSlice';
import NtxTable from '../../../../components/DataTable/NtxTable';
import Loading from '../../../../components/Shared/Loader/Loading';
 import useGetRotationPlan from '../../../../hooks/HR/use-get-RotationPlan';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
const Holidays = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const [search, setSearch] = useState('');
  const [id, setId] = useState('');
  const { RotationPlanOptions } = useGetRotationPlan();
  const [selectedRotationPlan, setSelectedRotationPlan] = useState(null);
  const { HasPermission } = usePermissions();
  useEffect(() => {
    if (selectedRotationPlan) {
      dispatch(getHolidaysList({ id: selectedRotationPlan }));
    } else {
      dispatch(getHolidaysList({}));
    }
  }, [selectedRotationPlan, dispatch]);

  const { HolidaysList: data, loading, error } = useAppSelector(s => s.Holidays);

  const filteredSearch = data?.slice()?.filter(item => {
    const searchLowerCase = search.toLowerCase();
    const matchesSearch = item.holidayName?.toLowerCase().includes(searchLowerCase);

    return matchesSearch;
  });

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Start Date'), key: 'startDateTime' },
    { title: t('Date_TO'), key: 'endDateTime' },
    { title: t('RotationPlan'), key: 'rotationPlanName' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = filteredSearch?.map(item => {
    let rowClass;

    return {
      Name: i18n.language === 'en' ? item.holidayName : item.holidayName2,
      startDateTime: item.holidayDateFrom?.split('T')[0],
      endDateTime: item.holidayDateTo?.split('T')[0],
      rotationPlanName: i18n.language === 'en' ? item.rotationPlanName : item.rotationPlanName2,
      action: (
        <>
          {HasPermission('ViewDetailsRaqHoliday') && (
            <>
              <button
                type='button'
                onClick={() => setId(item.id)}
                className='btn btn-sm btn-outline-theme me-1'
                data-bs-toggle='modal'
                data-bs-target='#modalEdit'
              >
                <i className='fa-solid fa-pen-to-square fa-lg me-2'></i>
                {t('Edit')}
              </button>
            </>
          )}
        </>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  var BcrumbList = [
    {
      name: 'Home',
     link: ':moduleHome'
    },
    {
      name: t('Holidays'),
      link: null
    }
  ];

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName='Holidays' />

        {/* {true && ( */}
        {HasPermission('AddRaqHoliday') && (
          <div className='ms-auto'>
            <Link to='' className='btn me-1 btn-theme' data-bs-toggle='modal' data-bs-target='#modalAdd'>
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('NewHoliday')}
            </Link>
          </div>
        )}
      </div>

      <Card>
        <CardBody>
          <div className='row  d-flex justify-content-between mb-3'>
            <div className='col-lg-4'>
              <div className='input-group flex-nowrap'>
                <span className='input-group-text fw-bold'>{t('Search')}</span>
                <div className='input-group'>
                  <div className='flex-fill position-relative'>
                    <div className='input-group border-0 '>
                      <div className='input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0'>
                        <i className='fa fa-search opacity-5 text-theme'></i>
                      </div>
                      <input
                        type='text'
                        autoComplete='off'
                        className='form-control ps-35px'
                        value={search}
                        onChange={e => {
                          setSearch(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-lg-4'>
              <div className='input-group flex-nowrap'>
                <span className='input-group-text  fw-bold'>{t('RotationPlan')}</span>

                <Select
                  classNamePrefix='react-select'
                  className='w-100'
                  isLoading={loading}
                  isSearchable={true}
                  isClearable
                  options={RotationPlanOptions}
                  onChange={(option: any) => setSelectedRotationPlan(option ? option.value : null)}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                />
              </div>
            </div>
          </div>

          <Loading loading={loading} error={error}>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              // enableSearch
              // showRecordsSelector
            />
          </Loading>
        </CardBody>
      </Card>

      <ModalComponent title={t('AddNewHoliday')} id='modalAdd'>
        <AddHolidays />
      </ModalComponent>

      <ModalComponent title={t('EditHoliday')} id='modalEdit'>
        {id && <UpdateHolidays id={id} />}
      </ModalComponent>
    </>
  );
};

export default Holidays;
